// let minOrderQty = 0;
//
document.addEventListener('DOMContentLoaded', function () {
    // Add Logo Accordions Start
    // Select all accordion buttons inside the accordion container
    const accordionButtons = document.querySelectorAll('#js-bsAccordionArtwork .accordion-button');

    // Fetch Stock Art
    async function fetchStockArt(pageNum, catId = 0) {
        const container = document.getElementById('js-stock-art-content');
        const stockArtUrl = `/partial/clipartview?PageNumber=${pageNum}&categoryId=${catId}`; 
        try {
            const response = await fetch(stockArtUrl);
            if (!response.ok) {
                throw new Error(`HTTP stock art error! status: ${response.status}`);
            }
            const data = await response.text();
            container.innerHTML = data;
        }
        catch (error) {
            //TODO: Add error in display
            console.error('Error fetching Stock Art:', error);
        }
    };

    // Fetch Saved Art
    async function fetchSavedArt() {
        const container = document.getElementById('js-saved-art-content');
        const savedArtUrl = '/partial/myartworkview';

        if (container) {
            try {
                const response = await fetch(savedArtUrl);
                if (!response.ok) {
                    throw new Error(`HTTP saved art error! status: ${response.status}`);
                }
                const data = await response.text();
                container.innerHTML = data;
            }
            catch (error) {
                //TODO: Add error in display
                console.error('Error fetching Saved Art:', error);
            } 
        }
    };

    // Close Bootstrap Accordion
    function closeBSAccordion(id) {
        let collapseElement = document.getElementById(id);
        let bsCollapse = new bootstrap.Collapse(collapseElement, {
            toggle: false
        });
        // const accordionItem = collapseElement?.closest('.accordion-item');
        let accordionItem = null;

        if (collapseElement) {
            accordionItem = collapseElement.closest('.accordion-item');
        }
        
        bsCollapse.hide();

        // remove highlighted border from accordion 
        if (accordionItem) {
            accordionItem.classList.remove("border", "border-3");
        }
    };

    accordionButtons.forEach(button => {
        const target = button.getAttribute('data-bs-target');
        const collapseElement = document.querySelector(target);
        const modifiedTarget = target.split('#js-').pop().toLowerCase();

        function executeFetch() {
            if (modifiedTarget === 'bssavedart') {
                fetchSavedArt();
            }

            if (modifiedTarget === 'bsstockart') {
                fetchStockArt(1);
            }
        }
        
        // CHECK IF ACCORDION IS OPEN (FOR ACE)
        if (collapseElement.classList.contains('show')){
            executeFetch()
        } else {
            button.addEventListener('click', () => {
                executeFetch()
            }, { once: true }); // adding once removes event listener after the first click
        }
    });
    // Add Logo Accordions End

    //Category select for Stock Art
    document.getElementById('js-bsStockArt').addEventListener('change', function(event){
        if (event.target.matches(".js-stockart-categorySelect")){
            const pageNumber = 1;
            const categoryId = event.target.value || 0;

            if (categoryId) {
                fetchStockArt(pageNumber, categoryId);
            }
        }
    });

    // Stock Art click events
    document.getElementById('js-bsStockArt').addEventListener('click', function(event){
        // Pagination for Stock Art
        if (event.target.matches(".page-link")){
            const pageNumber = event.target.getAttribute("data-pagenumber");
            const categoryId = event.target.getAttribute("data-categoryid") || 0;

            if (pageNumber) {
                fetchStockArt(pageNumber, categoryId);
            }
        }

        // handle clicks on stock art items
        const stockArtContainer = event.target.closest('.js-stock-art-item');
        if (stockArtContainer) {
            event.preventDefault();
                const categoryId = stockArtContainer.getAttribute("data-categoryid");
                const artCollectionId = stockArtContainer.getAttribute("data-artcollectionid");

                const imgElement = stockArtContainer.querySelector('img');
                const imgSrc = imgElement ? imgElement.src : null;
                if (categoryId && artCollectionId && imgSrc) {
                    Alpine.store('regularStore').stockArtImage = {categoryId, artCollectionId, imgSrc};
                    
                    // clear options radio inputs
                    Alpine.store('regularStore').checkIfAnyArtSelected();

                    // collapse bootstrap accordion
                    closeBSAccordion('js-bsStockArt');
                }

        }
    });

    // Saved Art click events
    document.getElementById('js-bsSavedArt').addEventListener('click', function(event){
        const savedArtContainer = event.target.closest('.js-saved-art-item')
        if (savedArtContainer) {
            const documentId = savedArtContainer.getAttribute('data-documentid');
            const fileName = savedArtContainer.getAttribute('data-filename');
            let imgSrc = null;

            const imgElement = savedArtContainer.querySelector('img');
            if (imgElement) {
               imgSrc = imgElement.getAttribute('src');
            } else {
                imgSrc = '/images/icon-nopreview.svg'
            }

            Alpine.store('regularStore').savedArtImage = {documentId, fileName, imgSrc};

            // clear options radio inputs
            Alpine.store('regularStore').checkIfAnyArtSelected();
            
            // collapse bootstrap accordion
            closeBSAccordion('js-bsSavedArt');
        }
    });

    // Alpine.data('imprintQtyManager', (root) => ({
    //     numberOfImprintColors: null,
    //
    //     async getColorDropdownHandler(){
    //         try {
    //             const store = Alpine.store('regularStore');
    //             if (!store.numberOfImprintColors) return;  // Exit if there are no colors
    //
    //             const imprintColorsParams = store.imprintColors
    //                 ? store.imprintColors.slice().reverse().map(c => `&selectColor=${c}`).join("")
    //                 : ""
    //
    //             const response = await fetch(`?handler=ImprintColors&qty=${store.numberOfImprintColors}${imprintColorsParams}`);
    //            
    //             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    //
    //             document.getElementById('js-color-select').innerHTML = await response.text();
    //         } catch (error) {
    //             console.error('Error fetching imprint colors dropdown:', error);
    //         }
    //     },
    //
    //     init() {
    //         const colorSelect = root.querySelector('#imprintColorCountSelector');
    //
    //         //set color qty
    //         Alpine.store('regularStore').numberOfImprintColors = Number(colorSelect.value || 0);
    //
    //         // get initial color dropdown
    //         this.getColorDropdownHandler();
    //
    //         // Bind input change to select
    //         colorSelect.addEventListener('change', (event) => {
    //             this.numberOfImprintColors = Number(event.target.value || 0);
    //             //update global store
    //             Alpine.store('regularStore').updateNumberOfImprintColors(Number(colorSelect.value || 0));
    //
    //             // Get color dropdowns
    //             this.getColorDropdownHandler();
    //
    //         });
    //     }
    // }));

});